import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SandboxComponent } from "./_components/_sandbox/sandbox/sandbox.component";
import { NotificationsComponent } from "./_components/notifications/notifications.component";
import { ReportsComponent } from "./_components/reports/reports.component";
import { UnsavedChangesGuard } from "./_helpers/guards/unsaved-changes.guard";
import { UnsavedChangesComponent } from "./_helpers/unsaved-changes/unsaved-changes.component";
import { GeographicAreasResolver } from "./_services/shared/geographic-areas/geographic-areas.resolver";
import { JurisdictionalAgenciesResolver } from "./_services/shared/jurisdictionalAgencies/jurisdictional-agencies.resolver";
import { SsoInitiationComponent } from "./_components/auth/sso-initiation/sso-initiation.component";
import { SsoResponseHandlerComponent } from "./_components/auth/sso-response-handler/sso-response-handler.component";
import { GaeStaffReportComponent } from "./gae-staff-report/gae-staff-report.component";
import { AuthGuard } from "./_helpers/guards/auth.guard";
import { SupportDashboardComponent } from "./support-dashboard/support-dashboard.component";
import { IrwinToolSmartComponent } from "./support-dashboard/irwin-tool-smart/irwin-tool-smart.component";
import { LinkConfigurationComponent } from "./support-dashboard/link-configuration-component/link-configuration-component.component";
import {MimicRolesComponent} from "./support-dashboard/mimic-roles/mimic-roles.component";
// import {MadcapTestComponent} from './_helpers/madcap-web-help/madcap-test.component';

const routes: Routes = [
  // {
  //   path: "madCapTest",
  //   component: MadcapTestComponent,
  //   data: { breadcrumb: "Mad Cap Test" },
  // },
  {
    path: "sandbox",
    loadChildren: ()=> import("./_modules/sandbox/sandbox.module").then(
      (m)=>m.SandboxModule
    ),
    component: SandboxComponent,
    data: { breadcrumb: "Sandbox" },
  },
  {
    path: "notifications",
    component: NotificationsComponent,
    data: { breadcrumb: "Notifications" },
  },
  {
    path: "support-dashboard",
    component: SupportDashboardComponent,
    children: [
        {
            path: "irwin-tool",
            component: IrwinToolSmartComponent,
            data: {tabName: "IRWIN"},
        },
        {
            path: "links",
            component: LinkConfigurationComponent,
            data: {tabName: "Link Configuration"},
        },
        {
            path: "mimic-roles",
            component: MimicRolesComponent,
            data: {tabName: "Mimic Roles"},
        }
    ],
    canActivate: [AuthGuard],
  },
  {
    path: "testing",
    component: UnsavedChangesComponent,
    canDeactivate: [UnsavedChangesGuard],
    data: { breadcrumb: "Testing" },
  },
  {
    path: "contactUs",
    loadChildren: () =>
      import("./_modules/contact-us/contact-us.module").then(
        (m) => m.ContactUsModule
      ),
  },
  {
    path: "resources",
    loadChildren: () =>
      import("./_modules/resources/resources.module").then(
        (m) => m.ResourcesModule
      ),
  },
  {
    path: "incidents",
    loadChildren: () =>
      import("./_modules/incident-search/incident-search.module").then(
        (m) => m.IncidentSearchModule
      ),
    canActivate: [AuthGuard],
  },
    {
    path: "reports",
    loadChildren: () =>
      import("./_modules/reports/reports.module").then(
        (m) => m.ReportsModule
      ),
    component: ReportsComponent,
    data: { breadcrumb: "Reports" }, // may be useless at this point
    canActivate: [AuthGuard],
  },
  {
    path: "users",
    loadChildren: () =>
      import("./_modules/users/users.module").then((m) => m.UsersModule),
  },
  {
    path: "gae-staff-report",
    component: GaeStaffReportComponent,
  },
  {
    path: "myHome",
    loadChildren: () =>
      import("./_modules/my-dashboard/my-dashboard.module").then(
        (m) => m.MyDashboardModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "auth",
    children: [
      { path: "sso", component: SsoInitiationComponent },
      { path: "validate", component: SsoResponseHandlerComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [GeographicAreasResolver, JurisdictionalAgenciesResolver],
})
export class AppRoutingModule {}
